export class Archiv {
    constructor(parsedIssues) {
        this.parsedIssues = parsedIssues;
        
        this.pageNum = document.querySelector('#page-num');
        
        this.buttons = {
            next : document.querySelector('#page-nav-next'),
            prev : document.querySelector('#page-nav-previous'),
            print : document.querySelector('#print-button'),
            copy : document.querySelector('#copy-button'),
            cut : document.querySelector('#cut-button'),
            backToSearch: document.querySelector('#backToSearch'),
        };
        
        this.alertContainer = document.querySelector('.alert-container'),
        
        this.loader = document.querySelector('#loading-dots');
        this.formSearch = document.querySelector('#search');
        this.formIssues = document.querySelector('#issues');
        this.formIssue = document.querySelector('#issue');
        
        this.results = document.querySelector('#result-row');
        this.details = document.querySelector('#detail-row');
        this.articleCol = document.querySelector('#articleCol');
        
        this.canvasArticle = document.querySelector('#article-canvas');
        
        this.inputFrom = document.querySelector('[name="from"]');
        this.inputTo = document.querySelector('[name="to"]');
        this.inputDate = document.querySelector('#date');
        this.inputDateWarning = document.querySelector('#group-date > .text-danger')
        
        this.searchForm = document.querySelector('#form-search');
        this.issueForm = document.querySelector('#form-issue');
        
        this.selectedNames = '';
        
        this.init();
    };
    
    init() {
        if(this.inputFrom) {
            this.searchForm.addEventListener('submit', event => {
                event.preventDefault();
                OVS.app.helper.toggleButton(true);
                this.results.classList.add('d-none');
                this.loader.classList.remove('d-none');
                let values = new FormData(this.searchForm);
                if(this.parseDate('dd.mm.yyyy',values.get('from')) <= this.parseDate('dd.mm.yyyy',values.get('to'))) {
                    //search and render results if issues have been selected
                    if(values.get('issues').length && values.get('search')) {
                        searchPhrase(values.get('search'),values.get('issues'),values.get('from'),values.get('to'),(results, archiveResult) => {
                            this.renderSearchResults(values.get('search'),results, null, archiveResult);
                        },1);
                    } else {
                        OVS.app.helper.toggleButton(false);
                    }
                }
            });
            
            this.issueForm.addEventListener('submit', event => {
                event.preventDefault();
                OVS.app.helper.toggleButton(true);
                this.results.classList.add('d-none');
                this.loader.classList.remove('d-none');
                let values = new FormData(this.issueForm);
                if(values.get('issue') && values.get('date')) {
                    this.inputDateWarning.classList.add('d-none');
                    searchIssue(values.get('issue'),values.get('date'),values.get('date'),(results) => {
                        this.renderSearchResults(values.get('issue'), results, this.formIssue.options[this.formIssue.selectedIndex].text);
                    });
                } else {
                    OVS.app.helper.toggleButton(false);
                    if(!values.get('date')) {
                        this.inputDateWarning.classList.remove('d-none');
                    }
                }
            });
            
            this.assignUserIssues(this.parsedIssues);
        }
        
        this.buttons.next.addEventListener('click', this.next.bind(this));
        this.buttons.prev.addEventListener('click', this.prev.bind(this));
        this.buttons.print.addEventListener('click', this.print.bind(this));
        this.buttons.copy.addEventListener('click', this.copy.bind(this));
        this.buttons.cut.addEventListener('click', this.clipboard.bind(this));
        this.buttons.backToSearch.addEventListener('click', () => {
            this.details.classList.add('d-none');
            this.results.classList.remove('d-none');
        });
    };
    
    //set issues to combobox
     assignUserIssues(issues) {
        //prevent duplicates caused by api
        let done = [];
        if(issues.length && issues.length > 0) {
            var options = [];
            issues.forEach(function(issue){
                //append to combos
                if(!done.includes(issue.pva)) {
                    options.push({value: issue.pva, text: issue.title});
                    done.push(issue.pva);
                }
            }.bind(this));
            OVS.app.helper.updateSelect(this.formIssue, options);
            options.unshift({value:'all', text:'Alle Ausgaben'});
            OVS.app.helper.updateSelect(this.formIssues, options, true);

            this.formIssues.value = 'all';
            
            // https://tom-select.js.org
            let select = new TomSelect('#issues', {
                closeAfterSelect: false,
                plugins: ['remove_button'],
                onItemAdd: function(value, $item) {
                    let items = this.items;
                    if(value == 'all') {
                        while(items.length > 1) {
                            if(items[0] != 'all') {
                                this.removeItem(items[0], true);
                            }
                        }
                    } else {
                        select.removeItem('all');
                    }
                }
            });
            this.loader.classList.add('d-none');
        }
    }
    
    //render results
    renderSearchResults(phrase, results, specific, archiveResult) {
        OVS.app.helper.toggleButton(false);
        //phrase is required for rendering
        if (phrase) {
            this.results.classList.remove('d-none');
            this.results.innerHTML = '';
            if (!results) {
                results = [];
            }

            let div = document.createElement('div');
            let h2 = document.createElement('h2');
            div.className = 'col-md-12';
            h2.className = 'form-heading';
            div.append(h2);

            if (!specific) {
                h2.textContent = results.length + ' Suchergebnisse zum Begriff "' + phrase + '"';
            } else {
                h2.textContent = results.length + ' Suchergebnisse aus ' + specific;
            }
            this.results.append(div);

            if (!specific) {
                results.forEach(result => {
                    this.results.insertAdjacentHTML('beforeend', this.renderResult(result, phrase));
                });
            } else {
                results.forEach(result => {
                    this.results.insertAdjacentHTML('beforeend', this.renderResultPages(result, phrase));
                });
            }

            let searchResults = document.querySelectorAll('.search-result-button');
            if (searchResults) {
                searchResults.forEach(searchResult => {
                    searchResult.addEventListener('click', () => {
                        let article = this.getFromSearchResultById(results, searchResult.dataset.articleId);
                        if (article) {
                            this.renderArticleResult(article, phrase);
                        }
                    });
                });
            }
            this.details.classList.add('d-none');
            this.loader.classList.add('d-none');
            //only implement paging for PhraseSearch
            if (archiveResult.archive.hits.total.value) {
                let total = archiveResult.archive.hits.total.value;
                const post = archiveResult.post[0];
                let paginationContainer = document.createElement('div');
                paginationContainer.className = 'pagination';
                this.results.append(paginationContainer);
                //get maximum page number
                let maxPages = Math.ceil(total/30);
                // Create hyperlink for first page
                let firstPageLink = document.createElement('a');
                firstPageLink.className = 'pagination__link';
                firstPageLink.textContent = 'Erste Seite';
                firstPageLink.href = '#';
                paginationContainer.append(firstPageLink);

                firstPageLink.addEventListener('click', () => {
                    //remove old result list to show loading
                    if (phrase) {
                        this.results.classList.remove('d-none');
                        this.results.innerHTML = '';
                        if (!results) {
                            results = [];
                        }
                    }
                    searchPhrase(post.phrase, post.issues, post.from, post.to, (results, value) => {
                        this.renderSearchResults(post.phrase, results, null, value);
                    }, 1);
                });
                //render active page button
                let activeButton = document.createElement('button');
                activeButton.className = 'pagination__bubble--active';
                activeButton.textContent = post.page;
                paginationContainer.append(activeButton);
                //render buttons before and after active page
                for (let i = Number(post.page) - 2; i <= Number(post.page) + 2; i++) {
                    if (i !== Number(post.page) && i >= 1 && i <= maxPages) {
                        let paginationButton = document.createElement('button');
                        paginationButton.className = 'pagination__bubble';
                        paginationButton.textContent = i;
                        if (i < Number(post.page)) {
                            paginationContainer.insertBefore(paginationButton, activeButton);
                        }
                        else {
                            paginationContainer.append(paginationButton);
                        }
                        paginationButton.addEventListener('click', () => {
                            //remove old result list to show loading
                            if (phrase) {
                                this.results.classList.remove('d-none');
                                this.results.innerHTML = '';
                                if (!results) {
                                    results = [];
                                }
                            }
                            searchPhrase(post.phrase, post.issues, post.from, post.to, (results, value) => {
                                this.renderSearchResults(post.phrase, results, null, value);
                            }, i);
                        });
                    }
                }
                // Create hyperlink for last page
                let lastPageLink = document.createElement('a');
                lastPageLink.className = 'pagination__link';
                lastPageLink.textContent = 'Letzte Seite';
                lastPageLink.href = '#';
                paginationContainer.append(lastPageLink);

                lastPageLink.addEventListener('click', () => {
                    //remove old result list to show loading
                    if (phrase) {
                        this.results.classList.remove('d-none');
                        this.results.innerHTML = '';
                        if (!results) {
                            results = [];
                        }
                    }
                    searchPhrase(post.phrase, post.issues, post.from, post.to, (results, value) => {
                        this.renderSearchResults(post.phrase, results, null, value);
                    }, maxPages);
                });
            }
        }
    };

    getFromSearchResultById(searchResult, id) {
        let foundArticle = null;
        if(searchResult && searchResult.length > 0) {
            searchResult.forEach(function(article){
                if(article._source.attributes && article._source.attributes.id === id) {
                    foundArticle = article;
                }
            });
        }
        return foundArticle;
    }
    
    renderArticleResult(article, phrase) {
        if(article) {
            this.article = article;
            //prepare visuals
            this.articleCol.innerHTML = '';
            this.articleCol.insertAdjacentHTML('beforeend', this.renderArticle(this.article, phrase));
            this.details.classList.remove('d-none');
            this.results.classList.add('d-none');
            //refit canvas
            fitCanvasDimensions(this.canvasArticle.offsetWidth, this.canvasArticle.offsetHeight);
            applyArticleToCanvas(this.article);
            //setup nav bar below
            this.pageNum.innerHTML = this.article._source.seite?"S."+this.article._source.seite:"(-)";
        }
    }
    
    next() {
        if(this.article._source.seite) {
            let max = 9999999; // todo: where to get the max amount of available pages
            if(this.article._source.seite < max){
                jumpToPageInIssue(this.article._source.seite+1,this.article._source.ausgabe,this.article._source.datum);
            }
        }
    };
    
    prev() {
        if(this.article._source.seite > 1) {
            jumpToPageInIssue(this.article._source.seite-1,this.article._source.ausgabe,this.article._source.datum);
        }
    };
    
    print() {
        //download / show the page
         let target;
         //check if date is old enough
         let issueDate = new Date(this.article._source.datum);
         let targetDate = new Date(issueDate.getTime() + 12096e5);
         let today = new Date();
         if(targetDate < today) {
             let split = this.article._source.datum.split("T");
             if(split[0]) {
                 target = window.location.origin+'/'+apiUrls.root+"/"+apiUrls.pdf+"?issue="+this.article._source.ausgabe+"&date="+this.article._source.datum.split("T")[0];
                 if(target) {
                     window.open(target);
                 }
                 else {
                     this.toast('PDF nicht verfügbar!','Die PDF-Datei konnte nicht abgerufen werden.', 'danger');
                 }
             }
         }
         else {
             this.toast('PDF noch nicht verfügbar!','Die PDF-Datei für diese Ausgabe liegt erst ab dem '+targetDate.getDate()+"."+(targetDate.getMonth()+1)+'.'+targetDate.getFullYear()+' vor.','warning');
         }
    };
    
    copy() {
        //download current page as image
        if(this.article._source.planungsdaten) {
            //current approach
            window.open(window.location.origin+'/'+apiUrls.root+"/"+apiUrls.image+"?imgName="+this.article._source.planungsdaten.page_preview_image);
        }
        else if(this.article._source.page_preview_image){
            //fallback of old approach
            window.open(window.location.origin+'/'+apiUrls.root+"/"+apiUrls.image+"?imgName="+this.article._source.page_preview_image);
        }
    };
    
    clipboard() {
        var copyText = document.querySelector('#currentArticle');
        const temp = document.createElement('input');
        temp.type = "text";
        temp.value = copyText.textContent;

        document.body.appendChild(temp);
        temp.select();
        document.execCommand("Copy");
        document.body.removeChild(temp);
        
        this.toast('Artikel kopiert!', 'Der Artikel kann an beliebiger Stelle eingefügt werden.');
    };
    
    renderResult(result,phrase) {
        result = result._source;
        //do not rely on existing data
        let imgsrc = null; //todo: insert placeholder image
        if(result.planungsdaten) {
            imgsrc = window.location.origin+'/'+apiUrls.root+"/"+apiUrls.image+"?imgName="+result.planungsdaten.page_preview_image;
        } //fallback if possible
        else if(result.page_preview_image) {
            imgsrc = window.location.origin+'/'+apiUrls.root+"/"+apiUrls.image+"?imgName="+result.page_preview_image;
        }
        //result.attributes.id + ".png";
        let issue = (result.ausgabentitel?result.ausgabentitel:'Schleswig-Holsteiner Nachrichten');
        let tDate = new Date(result.datum);
        let date = (tDate?tDate.toLocaleDateString('de-DE',{year:'numeric',month:'numeric',day:'numeric'}):"Unbek.");
        let page = (result.seite?"S."+result.seite:"n.Vorh.");
        let ressort = (result.ressort?result.ressort:'Diverses');
        let title = (result.title?result.title:"Artikel");
        let text = (result.text?result.text.replace(phrase, '<b>'+phrase+'</b>'):'mehr...');
        return `<div class="col-md-6 result-col">
                    <div class="backdrop">
                            <div class="wrapper search-result-button" data-article-id="${result.attributes.id}">
                                <div class="container">
                                    <div class="row result-container-row">
                                        <div class="col-md-5 result-col-img">
                                            <img class="result-img" src="${imgsrc}"/>
                                        </div>
                                        <div class="col-md-7 result-col-article">
                                            <h4>
                                                ${issue}
                                            </h4>
                                            <p class="meta">
                                                ${date} - ${page} - ${ressort}
                                            </p>
                                            <h4>
                                                ${title}
                                            </h4>
                                            <p>
                                                ${text}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
               </div>`;
    }
    
    renderArticle(article,phrase) {
        let issue = (article._source.ausgabentitel?article._source.ausgabentitel:'Schleswig-Holsteiner Nachrichten');
        let tDate = new Date(article._source.datum);
        let date = (tDate?tDate.toLocaleDateString('de-DE',{year:'numeric',month:'numeric',day:'numeric'}):"Unbek.");
        let page = (article._source.seite?"S."+article._source.seite:"n.Vorh.");
        let ressort = (article._source.ressort?article._source.ressort:'Diverses');
        let title = (article._source.title?article._source.title:"Artikel");
        let text = (article._source.text?article._source.text.replace(phrase, '<b>'+phrase+'</b>'):'mehr...');
        return `            
                <article id="currentArticle">
                    <h4>
                        ${issue}
                    </h4>
                    <p class="meta">
                        ${date} - ${page} - ${ressort}
                    </p>
                    <h4>
                        ${title}
                    </h4>
                    <p>
                        ${text}
                    </p>
                </article>
        `;
    }
    renderResultPages(result,phrase) {
        result = result._source;
        //do not rely on existing data
        let imgsrc = null; //todo: insert placeholder image
        //fallback if no article  found
        if (result.title === 'Artikel nicht gefunden!') {
            imgsrc = window.location.origin + '/assets/static/img/placeholderimage.png';
        }
        else{
            if(result.planungsdaten) {
                imgsrc = window.location.origin+'/'+apiUrls.root+"/"+apiUrls.image+"?imgName="+result.planungsdaten.page_preview_image;
            } //fallback if possible
            else if(result.page_preview_image) {
                imgsrc = window.location.origin+'/'+apiUrls.root+"/"+apiUrls.image+"?imgName="+result.page_preview_image;
            }
        }
        //result.attributes.id + ".png";
        let issue = (result.ausgabentitel?result.ausgabentitel:'Schleswig-Holsteiner Nachrichten');
        let page = (result.seite?"S."+result.seite:"n.Vorh.");
        return `<div class="col-md-4 result-col">
                    <div class="backdrop">
                            <div class="wrapper search-result-button" data-article-id="${result.attributes.id}">
                                <div class="container">
                                    <div class="row result-container-row">
                                        <div class="col-md-12 result-col-img">
                                            <h4>
                                                ${issue} - ${page}
                                            </h4>
                                            <img class="result-img" src="${imgsrc}"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
               </div>`;
    }
    //date render helper
    pad(num, size) {
        num = num.toString();
        while (num.length < size) num = "0" + num;
        return num;
    }

    //Helper for dates
    parseDate(format, input) {
        format = format || 'yyyy-mm-dd'; // default format
        var parts = input.match(/(\d+)/g),
            i = 0, fmt = {};
        // extract date-part indexes from the format
        format.replace(/(yyyy|dd|mm)/g, function(part) { fmt[part] = i++; });

        return new Date(parts[fmt['yyyy']], parts[fmt['mm']]-1, parts[fmt['dd']]);
    }

    //display an alert
    toast(title, text, mode = 'success') {
        let icon = '<svg class="bi flex-shrink-0 me-2" role="img" aria-label="Success:"><use xlink:href="#check-circle-fill"/></svg>';
        switch(mode) {
            case 'danger': icon = '<svg class="bi flex-shrink-0 me-2" role="img" aria-label="Warning:"><use xlink:href="#exclamation-triangle-fill"/></svg>'; break;
            case 'warning': icon = '<svg class="bi flex-shrink-0 me-2" role="img" aria-label="Info:"><use xlink:href="#info-fill"/></svg>'; break;
        }
        
        const uid = Date.now();
        const alert = document.createElement('div');
        alert.id = 'alert-' + uid;
        alert.role = 'alert';
        alert.className = 'alert alert-' + mode + ' alert-dismissible';
        alert.innerHTML = [
            `   <div>${icon} ${text}</div>`,
            '   <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>',
        ].join('')

        this.alertContainer.append(alert);
        this.autoclose(uid);
    };
    
    autoclose(uid) {
        setTimeout(() => {
            let autoclose = document.querySelector('#alert-' + uid);
            if(autoclose) {
                autoclose.remove();
            }
        }, 5000);
    };
};